import React, { useState } from 'react';
import { Popover, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import AccordianTable from '../../../testRunInstanceDashboard/Components/AccordianTable';

const defaultProps = {
  userThresholds: []
};

function ActivityLogRiskIndiModel({ userThresholds }) {
  const [isVisible, setIsVisible] = useState(false);

  const toggalPopover = () => setIsVisible(!isVisible);

  const hasData = !userThresholds?.length;
  return (
    <Popover
      content={<AccordianTable thresholds={userThresholds} />}
      visible={isVisible}
      autoAdjustOverflow={false}
      arrowPointAtCenter
      onVisibleChange={() => setIsVisible(false)}
      placement="bottomRight">
      <Button
        onClick={toggalPopover}
        icon={<MoreOutlined background="#B8BEC5" />}
        disabled={hasData}
      />
    </Popover>
  );
}

ActivityLogRiskIndiModel.defaultProps = defaultProps;

export default ActivityLogRiskIndiModel;
